export default __webpack_public_path__ + "28f37a44d82a3c2530ed7add74cec347.png";